import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { AppShell } from "../components/layout/AppShell";
import { NeuTabs } from "../components/neu/NeuTabs";
import { ExportButtons } from "../features/admin/ExportButtons";
import { ReportFilters } from "../features/admin/ReportFilters";
import { useReportData } from "../features/admin/useReportData";
import { useFeatures } from "../hooks/useFeatures";
import { ReportSection } from "../features/reports/ReportSection";
import { REPORT_KEYS, visibleReportTabs } from "../features/reports/reportTabs";

export default function ReportsPage() {
  const { t } = useTranslation();
  const data = useReportData(30);
  const features = useFeatures();
  const [params, setParams] = useSearchParams();
  const tab = REPORT_KEYS.includes(params.get("tab")) ? params.get("tab") : "attendance";

  return (
    <AppShell
      title={t("reports.title")}
      subtitle={t("reports.subtitle")}
      actions={<ExportButtons filters={data.filters} tab={tab} />}
    >
      <div className="grid gap-6">
        <ReportFilters
          filters={data.filters}
          setFilters={data.setFilters}
          branches={data.branches}
          employees={data.employees}
        />

        <NeuTabs
          testid="reports-tabs"
          value={tab}
          onChange={(key) => setParams(key === "attendance" ? {} : { tab: key })}
          tabs={visibleReportTabs(features).map(({ key, icon }) => ({ key, icon, label: t(`reports.tabs.${key}`) }))}
        />

        <div data-testid={`reports-panel-${tab}`}>
          {!data.filters.branch_id || !data.filters.user_id ? (
            <p className="rounded-3xl bg-background p-6 text-center text-sm font-bold text-muted-foreground shadow-neu-in"
               data-testid="reports-pick-hint">
              {t("payrollFilters.pickFirst")}
            </p>
          ) : (
            <ReportSection tab={tab} data={data} />
          )}
        </div>
      </div>
    </AppShell>
  );
}
